





















































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { CommonFormService} from "../../service/common-form.service";
import { CommonForm, SiteInfo } from "../../models/common-form";
import { ContentService } from "@/service/content.service";
import { DownloadContent } from "@/models/content/download";
import CommonMixin from "@/mixins/common-mixins";
import moment from 'moment'

@Component({
  components: {},
})
export default class Download extends Mixins(CommonMixin) {
  commonFormService = new CommonFormService();
  contentService = new ContentService();
  content: DownloadContent = {} as DownloadContent;
  hrefData = "";
  commonForm = {} as CommonForm;
  commonFormLoaded = false;
  haveBadToken = false;
  providerName = "";
  siteListText  = ""

  async mounted(): Promise<void> {
    try {
      this.content = await this.contentService.getDownloadContent();
      const token = this.$route.params.token;
      const secure = await this.commonFormService.getSecure(token);
      this.hrefData = `data:application/octet-stream,${secure.csv}`;
      this.commonForm = secure.commonForm;
      this.providerName = secure.providerName;

      if ( secure.siteData != null && secure.siteData.length > 0) {

        const siteList = secure.siteData[0].sites;
        this.siteListText = siteList.map( s => s.site).join(", ")
      }

      this.commonFormLoaded = true;
    } catch (error) {
      if (error.response.status === 422) {
        this.haveBadToken = true;
      }
    }
  }

  get languages(): string {
    const languages = [];
    if (this.commonForm.caregiver.speakenglish === true) {
      languages.push("English");
    }
    if (this.commonForm.caregiver.speakspanish === true) {
      languages.push("Spanish");
    }
    if (this.commonForm.caregiver.speakarabic === true) {
      languages.push("Arabic");
    }
    if (this.commonForm.caregiver.speakother === true) {
      languages.push(this.commonForm.caregiver.otherlanguage);
    }
    return languages.join(", ");
  }

  get formCompletedLanguage(): string {
    if (this.commonForm.language === "es") {
      return "Spanish";
    } else if (this.commonForm.language === "ar") {
      return "Arabic";
    } else {
      return "English";
    }
  }
  get phoneNumber(): string {
    let phoneNumber = "";
    if (this.commonForm != null && this.commonForm.caregiver != null) {
      phoneNumber = this.commonForm.caregiver.phonenumber ?? '';
      const numbersOnly = phoneNumber.replace(/\D/g, "");
      if (numbersOnly.length == 10) {
        phoneNumber = numbersOnly
          .replace(/[^0-9()-]/g, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
    }
    return phoneNumber;
  }

   get formSubmittedDate(): string {
    if ( this.commonForm.modifieddate != null) {
        return  moment(this.commonForm.modifieddate).format('MM/DD/YYYY');
    }
    return ''
  }
}
